export const load = () => ({
	title: 'Why Is My Room So Cold? How to Fix a Cold Room',
	showTitle: true,
});
